module.exports = __webpack_public_path__ + "img/Chile.979862a6.gif";